import { http, HttpResponse, HttpHandler } from 'msw';

const handlers: HttpHandler[] = [
  http.get('http://localhost/segment/v1/projects/:writeKey/settings', ({ params }) => {
    const writeKey = params.writeKey;

    const response = {
      integrations: {
        'Segment.io': {
          apiKey: writeKey,
          unbundledIntegrations: [],
          addBundledMetadata: false,
          versionSettings: { version: '4.4.7', componentTypes: ['browser'] },
          apiHost: 'localhost/segment/v1',
        },
      },
      plan: {
        track: { __default: { enabled: true, integrations: {} } },
        identify: { __default: { enabled: true } },
        group: { __default: { enabled: true } },
      },
      edgeFunction: {},
      analyticsNextEnabled: true,
      middlewareSettings: {},
      enabledMiddleware: {},
      metrics: { sampleRate: 0.1, host: 'localhost/segment/v1' },
      legacyVideoPluginsEnabled: false,
      remotePlugins: [],
    };

    return HttpResponse.json(response);
  }),

  http.post('https://localhost/segment/v1/i', () => {
    return HttpResponse.json({ success: true });
  }),

  http.post('https://localhost/segment/v1/p', () => {
    return HttpResponse.json({ success: true });
  }),

  http.post('https://localhost/segment/v1/t', () => {
    return HttpResponse.json({ success: true });
  }),
];

export { handlers };
